import * as React from "react";
import { inject, observer } from "mobx-react";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";

interface LinkToFileProps {
  uiFlagsStore?: UiFlagsStore;
  displayText: string;
  fileName: string;
  className?: string;
}

export function LinkToFile(props: LinkToFileProps): React.ReactElement<LinkToFileProps> {
  return (
    <a href={`${props.uiFlagsStore!.sourceDomain}${props.fileName}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`link-to-file ${props.className}`}
    >
      {props.displayText}
    </a>);
}

export default inject("uiFlagsStore")(observer(LinkToFile));
